import React from "react";
import { useTranslation } from "react-i18next";
import TailwindDropdown from "@components/TailwindDropdown";
import { ACTUAL_INDEX, SINGLE_RECORD } from "./constants";

const AttemptSelector = ({ attempts, selectedAttempt, onSelectAttempt }) => {
  const { t: translate } = useTranslation();

  if (!attempts || attempts.length <= SINGLE_RECORD) {
    return null;
  }

  return (
    <div className="tabs px-4">
      <TailwindDropdown
        data={attempts.map((item, index) => {
          return {
            key: index,
            value: `${translate("attempt-details.attempt")} ${
              index + ACTUAL_INDEX
            } (${item.BusinessDay} ${item.BDInstance})`,
          };
        })}
        selectedValue={attempts.indexOf(selectedAttempt)}
        setActiveTab={(index) => onSelectAttempt(index)}
      />
    </div>
  );
};

export default AttemptSelector;
